import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type SummaryCashTotalMultiClasses = 'total' | 'price' | 'inlinePrice' | 'centerPrices';

const summaryCashTotalMultiStyles = makeStyles<ISpcTheme, SummaryCashTotalMultiClasses>(
  theme => ({
    total: {
      color: theme.palette.primary.main,
    },
    price: {
      color: theme.palette.primary.main,
      fontFamily: theme.typography.fontFamily2,
      display: 'flex',
      alignItems: 'center',
      '& span': {
        alignSelf: 'flex-end',
      },
    },
    inlinePrice: {
      fontSize: theme.typography.fontLG,
      color: theme.palette.primary.main,
      fontFamily: theme.typography.fontFamily2,

      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.fontMD,
      },
    },
    centerPrices: {
      fontSize: theme.typography.fontXL,
      textAlign: 'center',
      display: 'inline-flex',
      justifyContent: 'center',
      [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        fontSize: theme.typography.fontLG,
      },
    },
  }),
  { name: 'ConfigSummary_SummaryCashTotalMulti' },
);

export default summaryCashTotalMultiStyles;
